import { DepartmentsEnum } from '@moonpig/web-core-types-graphql'
import { SuggestionType } from '../types'

const departmentPriority: Partial<Record<DepartmentsEnum, number>> = {
  [DepartmentsEnum.ALL_CARDS]: 0,
  [DepartmentsEnum.ALL_GIFTS]: 1,
  [DepartmentsEnum.ALL_FLOWERS_AND_PLANTS]: 2,
}
const deptPriority = (d: DepartmentsEnum) =>
  departmentPriority[d] ?? /* istanbul ignore next */ 99

const applyDepartmentPriority = (a: SuggestionType, b: SuggestionType) => {
  return deptPriority(a.department.enum) - deptPriority(b.department.enum)
}

export const mergeSuggestionsByScore = ({
  suggestions,
  maxSuggestions,
}: {
  suggestions: SuggestionType[]
  maxSuggestions: number
}) => {
  const seen = new Set<string>()
  return suggestions
    .slice()
    .sort((a, b) => {
      const scoreDiff = (b.score ?? 0) - (a.score ?? 0)
      if (scoreDiff !== 0) {
        return scoreDiff
      }
      return applyDepartmentPriority(a, b)
    })
    .filter(s => {
      const value = s.value.toLowerCase().trim()
      if (seen.has(value)) return false
      seen.add(value)
      return true
    })
    .slice(0, maxSuggestions)
}
